


// import useLeads from "../hooks/useLeads";

// const Rejects = () => {

//   const {
//     leads,
//     loading,
//     error,
//   } = useLeads();

//   // ================= FILTER REJECT =================
//   const rejectedLeads =
//     leads.filter(
//       (item) =>
//         item.lead_disposition ===
//         "Reject"
//     );

//   // ================= LOADING =================
//   if (loading) {

//     return (
//       <div className="p-10 text-center">
//         Loading...
//       </div>
//     );

//   }

//   // ================= ERROR =================
//   if (error) {

//     return (
//       <div className="p-10 text-center text-red-500">

//         Something went wrong

//       </div>
//     );

//   }

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">

//       <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-2xl p-6">

//         {/* HEADER */}
//         <div className="flex items-center justify-between mb-6">

//           <h2 className="text-2xl font-bold text-red-600">

//             Rejection List

//           </h2>

//           <span className="bg-red-100 text-red-700 px-4 py-1 rounded-full text-sm font-medium">

//             Total:
//             {" "}
//             {rejectedLeads.length}

//           </span>

//         </div>

//         {/* TABLE */}
//         <div className="overflow-x-auto">

//           <table className="w-full border-collapse">

//             <thead>

//               <tr className="bg-red-50 text-left">
//                 <th className="px-5 py-4 text-left">
//                   ID
//                 </th>
//                 <th className="px-5 py-4 text-left">
//                   Business Name
//                 </th>
//                 <th className="px-5 py-4 text-left">
//                   Phone
//                 </th>
//                 <th className="p-4">
//                   Supply Details
//                 </th>

//                 <th className="p-4">
//                   Supplier
//                 </th>
//                 <th className="p-4">
//                   Reject Reason
//                 </th>

//                 <th className="p-4">
//                   Review Status
//                 </th>

//                 <th className="p-4">
//                   Date
//                 </th>

//               </tr>

//             </thead>

//             <tbody>

//               {rejectedLeads.map((item) => (

//                 <tr
//                   key={item.id}
//                   className="border-b hover:bg-gray-50"
//                 >
//                   <td className="px-5 py-4">
//                     #{item.id}
//                   </td>
//                   {/* BUSINESS NAME */}
//                   <td className="px-5 py-4">
//                     {item.business_name}
//                   </td>
//                    {/* BUSINESS PHONE */}
//                   <td className="px-5 py-4">
//                     {item.business_phone}
//                   </td>
//                   {/*Supply Details */}
//                   <td className="p-4">

//                     {item.validation_type === "elec" && (
//                       <span className="text-sm font-medium text-slate-700">
//                         MPAN: {item.mpan || "-"}
//                       </span>
//                     )}

//                     {item.validation_type === "gas" && (
//                       <span className="text-sm font-medium text-slate-700">
//                         MPRN: {item.mprn_no || "-"}
//                       </span>
//                     )}

//                     {item.validation_type === "both" && (
//                       <div className="flex flex-col text-sm text-slate-700">

//                         <span>
//                           MPAN: {item.mpan || "-"}
//                         </span>

//                         <span>
//                           MPRN: {item.mprn_no || "-"}
//                         </span>

//                       </div>
//                     )}

//                   </td>
//                   {/* AUDIO */}

//                    <td className="p-4 text-gray-800 font-medium">

//                     {item?.electricity_supplier || item?.gas_supplier
//                     }

//                   </td>

//                   {/* FEEDBACK */}
//                   <td className="p-4 text-gray-600">

//                     {item.quality_feedback ||
//                       "No Feedback"}

//                   </td>

//                   {/* DISPOSITION */}
//                   <td className="p-4 text-gray-600">

//                     {item.lead_disposition}

//                   </td>


//                   {/* DATE */}
//                   <td className="p-4 text-gray-500 text-sm">

//                     {new Date(
//                       item.created_at
//                     ).toLocaleDateString()}

//                   </td>

//                 </tr>

//               ))}

//             </tbody>

//           </table>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default Rejects;


import { useState } from "react";
import useLeads from "../hooks/useLeads";
import { Link } from "react-router-dom";
const Rejects = () => {

  const {
    leads,
    loading,
    error,
  } = useLeads();

  const [idSearch, setIdSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  // const user = JSON.parse(localStorage.getItem("user"));
  // const isAgent = user?.role === "agent";
  // ================= FILTER REJECT =================
  const rejectedLeads =
    leads.filter(
      (item) =>
        item.lead_disposition ===
        "Reject"
    );

  // ================= SEARCH FILTER =================
  const filteredRejectedLeads = rejectedLeads.filter((item) => {
    const idTerm = idSearch.trim().toLowerCase();
    const phoneTerm = phoneSearch.trim().toLowerCase();

    const idOk = !idTerm || String(item.id).toLowerCase().includes(idTerm);
    const phoneOk = !phoneTerm || (item.business_phone || "").toLowerCase().includes(phoneTerm);

    return idOk && phoneOk;
  });

  const hasActiveSearch = idSearch.trim() || phoneSearch.trim();

  // ================= LOADING =================
  if (loading) {

    return (
      <div className="p-10 text-center">
        Loading...
      </div>
    );

  }

  // ================= ERROR =================
  if (error) {

    return (
      <div className="p-10 text-center text-red-500">

        Something went wrong

      </div>
    );

  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-2xl p-6">

        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">

          <h2 className="text-2xl font-bold text-red-600">

            Rejection List

          </h2>

          <span className="bg-red-100 text-red-700 px-4 py-1 rounded-full text-sm font-medium">

            Total:
            {" "}
            {filteredRejectedLeads.length}

          </span>

        </div>

        {/* SEARCH BARS */}
        <div className="flex flex-wrap gap-3 mb-6">

          {/* ID Search */}
          <div className="relative w-full sm:w-56">
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
            </svg>
            <input
              type="text"
              value={idSearch}
              onChange={(e) => setIdSearch(e.target.value)}
              placeholder="Search by ID..."
              className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-gray-300 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-transparent transition"
            />
            {idSearch && (
              <button
                onClick={() => setIdSearch("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>

          {/* Phone Search */}
          <div className="relative w-full sm:w-56">
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
            </svg>
            <input
              type="text"
              value={phoneSearch}
              onChange={(e) => setPhoneSearch(e.target.value)}
              placeholder="Search by phone..."
              className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-gray-300 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-transparent transition"
            />
            {phoneSearch && (
              <button
                onClick={() => setPhoneSearch("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>

          {/* Clear both */}
          {hasActiveSearch && (
            <button
              onClick={() => { setIdSearch(""); setPhoneSearch(""); }}
              className="px-4 py-2.5 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-semibold transition"
            >
              Clear filters
            </button>
          )}
        </div>

        {/* TABLE */}
        {filteredRejectedLeads.length === 0 ? (
          <div className="p-10 text-center text-gray-500">
            {hasActiveSearch ? "No rejects match your search" : "No rejected leads found"}
          </div>
        ) : (
          <div className="overflow-x-auto">

            <table className="w-full border-collapse">

              <thead>

                <tr className="bg-red-50 text-left">
                  <th className="px-5 py-4 text-left">
                    ID
                  </th>
                  <th className="px-5 py-4 text-left">
                    Business Name
                  </th>
                  <th className="px-5 py-4 text-left">
                    Phone
                  </th>
                  <th className="p-4">
                    Supply Details
                  </th>

                  <th className="p-4">
                    Supplier
                  </th>
                  <th className="p-4">
                    Reject Reason
                  </th>

                  <th className="p-4">
                    Review Status
                  </th>

                  <th className="p-4">
                    Date
                  </th>

                </tr>

              </thead>

              <tbody>

                {filteredRejectedLeads.map((item) => (

                  <tr
                    key={item.id}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="p-4">





                      <Link
                        to={`/reject-leads-details/${item.id}`}
                        className="text-blue-600 font-semibold hover:underline"
                      >
                        #{item.id}
                      </Link>

                    </td>
                    {/* BUSINESS NAME */}
                    <td className="px-5 py-4">
                      {item.business_name}
                    </td>
                    {/* BUSINESS PHONE */}
                    <td className="px-5 py-4">
                      {item.business_phone}
                    </td>
                    {/*Supply Details */}
                    <td className="p-4">

                      {item.validation_type === "elec" && (
                        <span className="text-sm font-medium text-slate-700">
                          MPAN: {item.mpan || "-"}
                        </span>
                      )}

                      {item.validation_type === "gas" && (
                        <span className="text-sm font-medium text-slate-700">
                          MPRN: {item.mprn_no || "-"}
                        </span>
                      )}

                      {item.validation_type === "both" && (
                        <div className="flex flex-col text-sm text-slate-700">

                          <span>
                            MPAN: {item.mpan || "-"}
                          </span>

                          <span>
                            MPRN: {item.mprn_no || "-"}
                          </span>

                        </div>
                      )}

                    </td>
                    {/* AUDIO */}

                    <td className="p-4 text-gray-800 font-medium">

                      {item?.electricity_supplier || item?.gas_supplier
                      }

                    </td>

                    {/* FEEDBACK */}
                    <td className="p-4 text-gray-600">

                      {item.quality_feedback ||
                        "No Feedback"}

                    </td>

                    {/* DISPOSITION */}
                    <td className="p-4 text-gray-600">

                      {item.lead_disposition}

                    </td>


                    {/* DATE */}
                    <td className="p-4 text-gray-500 text-sm">

                      {new Date(
                        item.created_at
                      ).toLocaleDateString()}

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>
        )}

      </div>

    </div>
  );
};

export default Rejects;